import { getManagementApiBaseUrl } from '../../utils/management-api';
import { id } from '@monorepo/tools/src/lib/types/primitives';
import { CrudEndpoint } from './crud.endpoint';

export class CampaignsEndpoint extends CrudEndpoint {
	constructor() {
		super('campaigns');
	}

	private get campaignsRootApi(): string {
		return getManagementApiBaseUrl();
	}

	private get campaignsBaseUrl(): string {
		return `${this.campaignsRootApi}/campaigns`;
	}

	list() {
		return this.campaignsBaseUrl;
	}

	create() {
		return this.campaignsBaseUrl;
	}

	get(id: id) {
		return `${this.campaignsBaseUrl}/${id}`;
	}

	edit(id: id) {
		return `${this.campaignsBaseUrl}/${id}`;
	}

	delete(id: id) {
		return `${this.campaignsBaseUrl}/${id}`;
	}

	targetListings(id: id) {
		return `${this.campaignsBaseUrl}/${id}/target-listings`;
	}

	inputOptions() {
		return `${this.campaignsRootApi}/input-options`;
	}

	addAndEditCreatives(id: id) {
		return `${this.campaignsBaseUrl}/${id}/creatives/bulk`;
	}

	enableCampaigns() {
		return `${this.campaignsBaseUrl}/status/ACTIVE`;
	}

	pauseCampaigns() {
		return `${this.campaignsBaseUrl}/status/PAUSED`;
	}

	attachDeals(id: id) {
		return `${this.campaignsBaseUrl}/${id}/deals/set-deals-related-to-campaign`;
	}

	targetList() {
		return `${this.campaignsBaseUrl}/shared-targets`;
	}

	sharedTargetAmount(id: id) {
		return `${this.campaignsBaseUrl}/shared-targets/${id}`;
	}

	bidKeys(id: id) {
		return `${this.campaignsBaseUrl}/${id}/bid-keys`;
	}

	uploadbidKeys(id: id) {
		return `${this.campaignsBaseUrl}/${id}/bid-keys/bin`;
	}

	sitesInTarget(id: id) {
		return `${this.campaignsBaseUrl}/${id}/sites-target-csv`;
	}

	uploadSitesInTarget(id: id) {
		return `${this.campaignsBaseUrl}/${id}/upload-sites-target`;
	}

	payout() {
		return `${this.campaignsBaseUrl}/payout/`;
	}
}
